module.exports = __webpack_public_path__ + "static/media/game-icon.0d5472b1.jpg";